<div class="answers"></div>
<div class="add editable">Add answer</div>
